import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from './assets/img/FigmaDDSSlicePNG27fc4de38f3da283fec465472e8ec088.png'
import _imports_1 from './assets/img/FigmaDDSSlicePNG43ad45b74447ebb4b199810652205b1a.png'
import _imports_2 from './assets/img/FigmaDDSSlicePNGc066228afdb3fa95d76d5da2908022cf.png'
import _imports_3 from './assets/img/FigmaDDSSlicePNG42043f770e041a69238596db9ed31e3d.png'
import _imports_4 from './assets/img/FigmaDDSSlicePNG64c558e9a9ad172b2af7d68e1f1a3ff5.png'
import _imports_5 from './assets/img/FigmaDDSSlicePNGd8bf1e20c7b6e772f8e5ccecbddfbb1f.png'
import _imports_6 from './assets/img/FigmaDDSSlicePNGa64dcce95d08f3ad71a07ae9245cbebc.png'
import _imports_7 from './assets/img/FigmaDDSSlicePNG94348678cb761fe7841c6a58913e543e.png'
import _imports_8 from './assets/img/FigmaDDSSlicePNG14bf3e51dc2bc842d003a66311eada9a.png'
import _imports_9 from './assets/img/FigmaDDSSlicePNG98dbb9ea6409f0c53bd1fb85afe2a97d.png'
import _imports_10 from './assets/img/FigmaDDSSlicePNG3a12e0f2635947659637dd09531c1c59.png'
import _imports_11 from './assets/img/FigmaDDSSlicePNG60b21620bd0dede6c3bb1836f2729bed.png'
import _imports_12 from './assets/img/FigmaDDSSlicePNGeaae2eb049353843bcf1849bbbe1ada2.png'
import _imports_13 from './assets/img/FigmaDDSSlicePNG0097e65f58326c976050f849896ea617.png'
import _imports_14 from './assets/img/FigmaDDSSlicePNG78fa3003223c56b5d2869e7732b54dcc.png'
import _imports_15 from './assets/img/FigmaDDSSlicePNG0ad6a3e6946024a2492f26967a95d733.png'
import _imports_16 from './assets/img/FigmaDDSSlicePNGf5947b65b87fa10793926bda3bff2f85.png'
import _imports_17 from './assets/img/FigmaDDSSlicePNGc5ce9d26733c4584997d7b69dab1179d.png'
import _imports_18 from './assets/img/FigmaDDSSlicePNG112c5b5f54d864828cc6db0f6368b751.png'
import _imports_19 from './assets/img/FigmaDDSSlicePNGee9662e52387d993b4deb648bac50345.png'
import _imports_20 from './assets/img/FigmaDDSSlicePNGa8df8aa575b03512e329b083a3b2a65e.png'
import _imports_21 from './assets/img/FigmaDDSSlicePNGbeec428229cbc97454fbf3a9e1b4371e.png'
import _imports_22 from './assets/img/FigmaDDSSlicePNG891c1bf8bcdb225465d85da7fc7f4d43.png'
import _imports_23 from './assets/img/FigmaDDSSlicePNGb64c766c5ef62f077b8b46bb11c8242e.png'
import _imports_24 from './assets/img/FigmaDDSSlicePNG82395ff4bed5e655603171961b5e9e07.png'
import _imports_25 from './assets/img/FigmaDDSSlicePNGa0d2bef56929ed042e0b2d75ede5b23f.png'
import _imports_26 from './assets/img/FigmaDDSSlicePNGcee76738026af3d147309aced79ca890.png'
import _imports_27 from './assets/img/FigmaDDSSlicePNGaded519179c2e1660c49616bf109a537.png'


const _hoisted_1 = { class: "page flex-col" }
const _hoisted_2 = { class: "group_1 flex-col" }
const _hoisted_3 = { class: "image-wrapper_1 flex-row" }
const _hoisted_4 = { class: "group_2 flex-col" }
const _hoisted_5 = { class: "image-wrapper_3 flex-row" }
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "image_1",
          referrerpolicy: "no-referrer",
          src: _imports_0,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push('/')))
        }),
        _createElementVNode("img", {
          class: "image_2",
          referrerpolicy: "no-referrer",
          src: _imports_1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push('/')))
        }),
        _createElementVNode("img", {
          class: "image_3",
          referrerpolicy: "no-referrer",
          src: _imports_2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.scrollIntoView('image_13', 50)))
        }),
        _createElementVNode("img", {
          class: "image_4",
          referrerpolicy: "no-referrer",
          src: _imports_3,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.scrollIntoView('image-wrapper_5', -90)))
        }),
        _createElementVNode("img", {
          class: "image_5",
          referrerpolicy: "no-referrer",
          src: _imports_4,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollIntoView('image_23', 0)))
        }),
        (_ctx.isLogin)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "image_6",
              referrerpolicy: "no-referrer",
              src: _imports_5,
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.CreateGame && _ctx.CreateGame(...args)))
            }))
          : _createCommentVNode("", true),
        (!_ctx.isLogin)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "image_7",
              referrerpolicy: "no-referrer",
              src: _imports_6,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (this.$router.push('/login')))
            }))
          : _createCommentVNode("", true),
        (_ctx.isLogin)
          ? (_openBlock(), _createBlock(_component_el_dropdown, {
              key: 2,
              "show-timeout": "0",
              "hide-timeout": "50",
              size: "large",
              class: "detail"
            }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_dropdown_item, { command: "cn" }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", null, _toDisplayString(_ctx.userInfo.name), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, {
                      command: "cn",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (this.$router.push('/list')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", null, _toDisplayString(_ctx.$t("home.list")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, {
                      command: "en",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (this.$router.push('/setting')))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", null, _toDisplayString(_ctx.$t("home.Setting")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_dropdown_item, {
                      command: "jp",
                      onClick: _ctx.logout
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", null, _toDisplayString(_ctx.$t("home.logout")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_avatar, {
                  src: _ctx.userInfo.avatar,
                  class: "avatar"
                }, null, 8, ["src"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_dropdown, {
          "show-timeout": "0",
          "hide-timeout": "50",
          onCommand: _ctx.handleCommand
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { command: "cn" }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("简体中文")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { command: "en" }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("English")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { command: "jp" }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("繁体中文")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _cache[16] || (_cache[16] = _createElementVNode("img", {
              class: "image_8",
              referrerpolicy: "no-referrer",
              src: _imports_7
            }, null, -1))
          ]),
          _: 1
        }, 8, ["onCommand"])
      ]),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "image-wrapper_2 flex-row" }, [
        _createElementVNode("img", {
          class: "image_9",
          referrerpolicy: "no-referrer",
          src: _imports_8
        })
      ], -1)),
      _cache[18] || (_cache[18] = _createElementVNode("img", {
        class: "image_10",
        referrerpolicy: "no-referrer",
        src: _imports_9
      }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[19] || (_cache[19] = _createElementVNode("img", {
        class: "image_11",
        referrerpolicy: "no-referrer",
        src: _imports_10
      }, null, -1)),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loopData0, (item, index) => {
          return (_openBlock(), _createElementBlock("img", {
            class: "image_12",
            referrerpolicy: "no-referrer",
            src: item.lanhuimage0,
            key: index
          }, null, 8, _hoisted_6))
        }), 128))
      ]),
      _cache[20] || (_cache[20] = _createElementVNode("img", {
        class: "image_13",
        id: "image_13",
        referrerpolicy: "no-referrer",
        src: _imports_11
      }, null, -1)),
      _createElementVNode("img", {
        class: "image_14",
        id: "image_14",
        referrerpolicy: "no-referrer",
        src: _imports_12,
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.changeRouter && _ctx.changeRouter(...args)))
      }),
      _createElementVNode("img", {
        class: "image_15",
        referrerpolicy: "no-referrer",
        src: _imports_13,
        onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.changeRouter && _ctx.changeRouter(...args)))
      }),
      _createElementVNode("img", {
        class: "image_16",
        referrerpolicy: "no-referrer",
        src: _imports_14,
        onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.changeRouter && _ctx.changeRouter(...args)))
      }),
      _createElementVNode("img", {
        class: "image_17",
        referrerpolicy: "no-referrer",
        src: _imports_15,
        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.changeRouter && _ctx.changeRouter(...args)))
      })
    ]),
    _cache[21] || (_cache[21] = _createStaticVNode("<div class=\"group_3 flex-col\" data-v-ebd08756><img class=\"image_18\" referrerpolicy=\"no-referrer\" src=\"" + _imports_16 + "\" data-v-ebd08756><div class=\"image-wrapper_4 flex-row justify-between\" data-v-ebd08756><img class=\"image_19\" referrerpolicy=\"no-referrer\" src=\"" + _imports_17 + "\" data-v-ebd08756><img class=\"image_20\" referrerpolicy=\"no-referrer\" src=\"" + _imports_18 + "\" data-v-ebd08756></div></div><div class=\"image-wrapper_5 flex-col\" id=\"image-wrapper_5\" data-v-ebd08756><img class=\"image_21\" referrerpolicy=\"no-referrer\" src=\"" + _imports_19 + "\" data-v-ebd08756><img class=\"image_22\" referrerpolicy=\"no-referrer\" src=\"" + _imports_20 + "\" data-v-ebd08756></div><div class=\"group_4 flex-col\" data-v-ebd08756><img class=\"image_23\" id=\"image_23\" referrerpolicy=\"no-referrer\" src=\"" + _imports_21 + "\" data-v-ebd08756><img class=\"image_24\" referrerpolicy=\"no-referrer\" src=\"" + _imports_22 + "\" data-v-ebd08756><img class=\"image_25\" referrerpolicy=\"no-referrer\" src=\"" + _imports_23 + "\" data-v-ebd08756><div class=\"image-wrapper_6 flex-row justify-between\" data-v-ebd08756><a href=\"https://apps.apple.com/cn/app/mapgame/id6740665605\" target=\"_blank\" data-v-ebd08756><img class=\"image_26\" referrerpolicy=\"no-referrer\" src=\"" + _imports_24 + "\" data-v-ebd08756></a><a href=\"https://www.pgyer.com/chufaba-android\" target=\"_blank\" data-v-ebd08756><img class=\"image_27\" referrerpolicy=\"no-referrer\" src=\"" + _imports_25 + "\" data-v-ebd08756></a></div><img class=\"image_28\" referrerpolicy=\"no-referrer\" src=\"" + _imports_26 + "\" data-v-ebd08756><img class=\"image_29\" referrerpolicy=\"no-referrer\" src=\"" + _imports_27 + "\" data-v-ebd08756></div>", 3))
  ]))
}